<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <!--          <a-col :md='6' :sm='6'>-->
          <!--            <a-form-item label='放款日期'>-->
          <!--              <a-range-picker-->
          <!--                v-model='queryParam.time'-->
          <!--                format='YYYY-MM-DD'-->
          <!--                style='width: 200px;' />-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :md='8' :sm='8'>
            <a-form-item label='老户放款数量'>
              <a-input-number :min='0' style='width: 220px' v-model='RegularUsersLoansNum'
                              @change='RegularUsersLoansNumChange'></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <a-form-item label='新户放款数量'>
              <a-input-number :min='0' style='width: 220px' v-model='NewUsersLoansNum'
                              @change='NewUsersLoansNumChange'></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='4'>
            <a-form-item label='顺序'>
              <a-select style='width: 120px' v-model='QueryOrderValue' @change='QueryOrderChange'>
                <a-select-option value='1'>
                  正序
                </a-select-option>
                <a-select-option value='0'>
                  倒序
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='4'>
                      <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
          <!--              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>-->
                        <a-button type='primary' @click='searchanDownload' icon='download'
                                  style='margin-left: 20px;'>生成放款批次</a-button>
                        <!--                        <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 20px'>{{ $t('reset')-->
                        <!--                          }}</a-button>-->
                      </span>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='6'>
            <a-form-item label='支付方式'>
              <a-select style='width: 220px' allowClear v-model='queryParam.payChannel' @change='payChannelChange'>
                <a-select-option v-for='item in payChannelRes' :value='item.payChannel'>{{ item.payChannel }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-upload
              name='file'
              :multiple='true'
              :action="'/api/web/webpublic/batchPayments/import-payment'"
              :headers='getHeaders()'
              :data='uploadDataParam'
              :openFileDialogOnClick='openFileDialogOnClick'
              @change='handleChangeUpload'
            >
              <a-button @click='clickUploadFile' style='margin-left: 8px'>
                <a-icon
                  type='upload' />
                Click to Upload
              </a-button>
            </a-upload>
          </a-col>
          <a-col :md='4' :sm='4'>
                      <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                        <a-button type='primary' @click='searchReset' icon='reload'
                                  style='margin-left: 20px'>{{ $t('reset')
                          }}</a-button>
                      </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        :rowSelection="{columnTitle:'选择',onChange: selectRowsChange, selectedRowKeys ,type:'checkbox'}"
        @change='handleTableChange'>
        <span slot='action' slot-scope='text, record'>
            <a @click='downloadBtn(record)'>下载 </a>
        </span>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getLoanList, getLimitData, importRecordPayment } from '@/webpublicapi/TripartiteLoan'
import { getHeaders } from '@/utils/request'
import moment from 'moment'
import { datetime } from 'mockjs2/src/mock/random/date'

const I18N_KEY = {
  OASYSTEM: 'oaSystem.',
  FOLLOW: 'importPayoutOrder.'
}
export default {
  name: 'importPayoutOrder',
  components: {},
  data() {
    return {
      checkbosNum: [],
      batchIdNum: '',
      selectedRowKeys: [],
      openFileDialogOnClick: false,
      QueryOrderValue: '正序',
      NewUsersLoansNum: '',
      RegularUsersLoansNum: '',
      visdialog: false,
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      dataSourceTotal: [],
      departments: [],
      groupAll: [],
      normalConfigList: [],
      // 查询条件
      queryParam: {
        time: [],
        payChannel: ''
      },
      limitParam: '',//查询条件
      loading: false,
      // 表头
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      uploadDataParam: {},
      payChannelRes: [
        {
          payChannel: 'moneySpace',
          data: {
            payOutIdIndex: 8,
            statusIndex: 5,
            sheetIndex: 0,
            payChannel: 'moneySpace',
            successMarkMsg: 'success'
          }
        }
      ]
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '订单id',
          align: 'left',
          dataIndex: 'orderIds'
        },
        {
          title: '放款时间',
          align: 'center',
          dataIndex: 'payoutTime'
        },
        {
          title: '创建时间（导出时间）',
          align: 'center',
          dataIndex: 'createTime'
        },
        // {
        //   title: '放款状态',
        //   align: 'center',
        //   dataIndex: 'payoutStatus',
        //   // customRender: function(text) {
        //   //   if (text === '00') {
        //   //     return '初始化'
        //   //   } else if (text === '01') {
        //   //     return '成功'
        //   //   } else if (text === '02') {
        //   //     return '失败'
        //   //   } else if (text === '03') {
        //   //     return '放款中'
        //   //   } else if (text === '999') {
        //   //     return '系统内部异常'
        //   //   }
        //   // }
        // },
        {
          title: '放款状态',
          align: 'center',
          dataIndex: 'payoutStatus'
        },
        {
          title: '批次id',
          align: 'center',
          dataIndex: 'batchId'
        },
        {
          title: '已放款orderId',
          align: 'center',
          dataIndex: 'payoutOrderId'
        },
        {
          title: '待放款总金额',
          align: 'center',
          dataIndex: 'unpaidAmount'
        },
        {
          title: '已放款总金额',
          align: 'center',
          dataIndex: 'loanAmount'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'action' }
        }

      ]
    }
  },
  created() {
    this.getTime()
    this.loadData(1)
  },
  methods: {
    downloadBtn(record) {
      console.log('record！！！', record)
      let orderIds = record.orderIds
      console.log('record---batchId！！！', orderIds)
      importRecordPayment(Object.assign({}, { orderIds })).then((res) => {
        console.log('importRecordPayment-----》', res)
        // 创建可下载的URL地址
        const downloadUrl = URL.createObjectURL(res)
        // 创建a标签
        const a = document.createElement('a')
        a.href = downloadUrl
        // 设置要保存的文件名
        a.download = record.createTime + ' ' + record.batchId + '.xlsx'
        // 模拟点击a标签，触发下载
        a.click()
        // 清理URL对象
        URL.revokeObjectURL(downloadUrl)
        this.$message.success('下载成功！')
        this.loadData(1)
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    selectRowsChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.checkbosNum = selectedRows
      console.log('选择了一行数据！！！')
      if (selectedRows.length) {
        this.batchIdNum = selectedRows[selectedRows.length - 1].batchId
        console.log('selectedRowKeys---->', selectedRowKeys)
        console.log('selectedRows--->', selectedRows)
        console.log(' this.batchIdNum--->', this.batchIdNum)
        this.uploadDataParam.batchId = this.batchIdNum
        console.log(' this.uploadDataParam--->', this.uploadDataParam)
      }
    },
    clickUploadFile() {
      console.log('this.checkbosNum', this.checkbosNum)
      console.log('this.queryParam-->', this.queryParam)
      if (this.checkbosNum.length > 1) {
        this.openFileDialogOnClick = false
        this.$message.error('最多选择表格中的一条记录！')
      } else if (this.queryParam.payChannel == undefined || this.batchIdNum == '') {
        this.openFileDialogOnClick = false
        this.$message.error('请选择支付方式和表格中的一条记录！')
      } else {
        this.openFileDialogOnClick = true
      }

    },
    QueryOrderChange(e) {
      console.log('下拉框改变了!!!', e)
      this.QueryOrderValue = e
    },
    RegularUsersLoansNumChange(e) {
      console.log('老用户放款数变了', e)
      this.RegularUsersLoansNum = e
    },
    NewUsersLoansNumChange(e) {
      console.log('新用户放款数变了', e)
      this.NewUsersLoansNum = e
    },
    payChannelChange(value) {
      console.log('value是什么？', value)
      console.log('this.payChannelRes？', this.payChannelRes)
      var isIn = false
      for (const payChannelInfo of this.payChannelRes) {
        if (payChannelInfo.payChannel === value) {
          this.uploadDataParam = payChannelInfo.data
          isIn = true
        }
      }
      this.uploadDataParam.batchId = this.batchIdNum
      if (!isIn) {
        this.uploadDataParam = {}
      }
      console.log('this.uploadDataParam', this.uploadDataParam)
    },
    getTime() {
      this.queryParam.time = []
      var nowDate = new Date()
      this.queryParam.time[0] = moment(nowDate.setDate(nowDate.getDate() - 7))
      this.queryParam.time[1] = moment(new Date())

    },
    getHeaders() {
      return getHeaders()
    },
    searchQuery() {
      this.loadData(1)
    },

    searchanDownload() {
      console.log('点击了生成放款批次!!')
      this.loadLimitData(1)

    },
    loadLimitData(arg) {
      // console.log('旧', this.RegularUsersLoansNum)
      // console.log('新', this.NewUsersLoansNum)
      // console.log('选的正序还是倒序?', this.QueryOrderValue)
      if (this.QueryOrderValue == '正序') {
        this.QueryOrderValue = '1'
      }
      console.log('this.RegularUsersLoansNum新---', this.RegularUsersLoansNum)
      console.log('this.NewUsersLoansNum旧---', this.NewUsersLoansNum)
      if (this.RegularUsersLoansNum >= 0 && (this.RegularUsersLoansNum !== '' && this.RegularUsersLoansNum !== null && this.RegularUsersLoansNum !== undefined)) {
        console.log('old条件成立')
      } else this.$message.error('老户放款数量不能为空！')
      if (this.NewUsersLoansNum >= 0 && (this.NewUsersLoansNum !== '' && this.NewUsersLoansNum !== null && this.NewUsersLoansNum !== undefined)) {
        console.log('new条件成立')
      } else this.$message.error('新户放款数量不能为空！')

      this.limitParam = `${this.NewUsersLoansNum},${this.RegularUsersLoansNum},${this.QueryOrderValue}`
      let limits = this.limitParam //字符串
      console.log('准备发请求咯!!!', limits)
      if ((this.NewUsersLoansNum !== '' && this.NewUsersLoansNum !== null && this.NewUsersLoansNum !== undefined) && (this.RegularUsersLoansNum !== '' && this.RegularUsersLoansNum !== null && this.RegularUsersLoansNum !== undefined) && this.QueryOrderValue) {
        console.log('可以发请求')
        getLimitData(Object.assign({}, { limits })).then((res) => {
          console.log('getLimitData-----》', res)
          if (res.size == 0) {
            this.$message.error('暂无放款数据！')
          } else {
            // 创建可下载的URL地址
            const downloadUrl = URL.createObjectURL(res)
            // 创建a标签
            const a = document.createElement('a')
            a.href = downloadUrl
            // 设置要保存的文件名
            // a.download = 'document.xlsx'
            a.download = new Date().getTime() + '.xlsx'
            // 模拟点击a标签，触发下载
            a.click()
            // 清理URL对象
            URL.revokeObjectURL(downloadUrl)
            this.$message.success('下载成功！')
            this.loadData(1)
          }

        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      } else {
        console.log('不可以发请求！')
      }
    },
    loadData(arg) {
      var params = this.getQueryParams()// 查询条件
      // if (!params.beginTime) {
      //   this.$message.error('放款日期不能为空')
      //   return
      // }
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true

      getLoanList(Object.assign({}, params)).then((res) => {
        console.log('加载默认数据列表的接口')
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
          console.log('query-payment---看看拿到的数据是啥？', res.data.list)
          console.log('dataSource--->', this.dataSource)
          console.log('this.total', this.total)
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    }
    ,
    getQueryParams() {
      var param = this.queryParam
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      // param.beginTime = (param.time && param.time.length) ? this.transformTime(param.time[0]) : undefined
      // param.endTime = (param.time && param.time.length) ? this.transformTime(param.time[1]) : undefined

      return filterObj(param)
    }
    ,
    transformTime(time) {
      return time.format('YYYY-MM-DD')
    }
    ,
    handleTableChange(pageNum, pageSize) {
      console.log(1111)
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    }
    ,
    // 重置搜索框的内容
    searchReset() {
      console.log('重置！')
      var that = this
      // that.getTime()
      that.queryParam.dataDt = [moment().add('days', -15), moment().add('days', -1)]
      that.queryParam.payChannel = ''
      that.RegularUsersLoansNum = ''
      that.NewUsersLoansNum = ''
      that.QueryOrderValue = '正序'
      that.loadData()
    }
    ,
    handleChangeUpload(info) {
      console.log(2222)
      console.log('info----->', info)
      console.log(' queryParam.payChannel--->', this.queryParam.payChannel)
      // if (this.queryParam.payChannel==undefined) {
      //   this.$message.error('请选择方式！')
      //   console.log('没选支付方式')
      // } else {
      //   this.openFileDialogOnClick = true
      console.log('选择了支付方式')
      //debugger;
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
        console.log(1)
      }
      if (info.file.status === 'done') {
        console.log('上传成功！')
        if (info.file.response.code === 1000) {
          //alert('handle success!');
          this.$message.success(`${info.file.name} file uploaded successfully`)
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        console.log(3)
        //this.$message.error(`${info.file.name} file upload failed.`);
        alert('system error!')
      }
      // }
      console.log('准备刷新页面！')
      this.loadData(1)
      console.log('页面刷新成功！')
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
